import script from "./EventSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearch.vue?vue&type=script&setup=true&lang=js"

import "./EventSearch.vue?vue&type=style&index=0&id=686a5dd4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686a5dd4"]])

export default __exports__